(function () {
  const PREFILTER_KEY = 'filter.p.m.custom.fm';
  const PREFILTER_VALUE = '1';

  const COUNT_SELECTOR = '.maison-product-count';
  const GRID_SELECTOR = '.product-grid-container';
  const FACETS_DRAWER_SELECTOR = '.maison-facets-drawer facets-form-component';

  const OVERRIDE_FILTERS = [
    'filter.v.m.custom.production_time_override',
    'filter.p.m.custom.color_label',
  ];

  let patchedFacetsForm = null;
  let booted = false;
  let waiting = false;
  let mutationObserver = null;
  let initialLoadDone = false;

  /* ---------------- HELPERS ---------------- */

  function getCurrentURL() {
    return new URL(window.location.href);
  }

  function hasOverrideInParams(params) {
    return OVERRIDE_FILTERS.some((key) => params.has(key));
  }

  function normalizeSearchParams(params) {
    const normalized = new URLSearchParams(params);
    const hasOverride = hasOverrideInParams(normalized);

    if (hasOverride) {
      normalized.delete(PREFILTER_KEY);
    } else {
      normalized.set(PREFILTER_KEY, PREFILTER_VALUE);
    }

    return normalized;
  }

  function normalizeURL(input) {
    const url = new URL(input, window.location.origin);
    url.search = normalizeSearchParams(url.searchParams).toString();
    return url;
  }

  function buildPrefilterURL() {
    return normalizeURL(getCurrentURL());
  }

  /* ---------------- COUNT ---------------- */

  function revealCount() {
    const countEl = document.querySelector(COUNT_SELECTOR);
    if (!countEl) return;

    const observer = new MutationObserver(() => {
      countEl.style.visibility = 'visible';
      observer.disconnect();
    });

    observer.observe(countEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    setTimeout(() => {
      countEl.style.visibility = 'visible';
      observer.disconnect();
    }, 1500);
  }

  /* ---------------- SIDEBAR ---------------- */

  function fetchAndSwapSidebar(fromURL) {
    const sidebarURL = new URL(fromURL.toString());
    sidebarURL.searchParams.delete(PREFILTER_KEY);

    return fetch(sidebarURL.toString())
      .then((r) => r.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newForm = parsed.querySelector(FACETS_DRAWER_SELECTOR);
        const currentForm = document.querySelector(FACETS_DRAWER_SELECTOR);

        if (!newForm || !currentForm) return;

        // preserve open state
        const openIds = [...currentForm.querySelectorAll('details[open]')]
          .map((el) => el.id)
          .filter(Boolean);

        currentForm.replaceWith(newForm);

        const replacedForm = document.querySelector(FACETS_DRAWER_SELECTOR);

        openIds.forEach((id) => {
          const el = replacedForm.querySelector(`details#${id}`);
          if (el) el.setAttribute('open', '');
        });

        patchFacetsForm(getReadyFacetsForm());
      });
  }

  /* ---------------- PATCH ---------------- */

  function patchFacetsForm(facetsForm) {
    if (!facetsForm) return false;
    if (facetsForm.__maisonPrefilterPatched) return true;
    if (typeof facetsForm.createURLParameters !== 'function') return false;
    if (typeof facetsForm.updateFiltersByURL !== 'function') return false;

    const originalCreate = facetsForm.createURLParameters.bind(facetsForm);
    const originalUpdate = facetsForm.updateFiltersByURL.bind(facetsForm);

    facetsForm.createURLParameters = function (formData) {
      const params = originalCreate(formData);

      const currentURL = getCurrentURL();
      const currentSort = currentURL.searchParams.get('sort_by');

      if (!params.has('sort_by') && currentSort) {
        params.set('sort_by', currentSort);
      }

      return normalizeSearchParams(params);
    };

    facetsForm.updateFiltersByURL = function (url) {
      const normalizedURL = normalizeURL(url);

      history.pushState('', '', normalizedURL.toString());

      // 🔥 count reveal stays correct
      document.addEventListener('filter:update', revealCount, { once: true });

      // 👉 GRID = normalized (with prefilter logic)
      originalUpdate(normalizedURL.toString());

      // 👉 SIDEBAR = RAW url (user intent) minus prefilter
      const sidebarURL = new URL(url, window.location.origin);
      sidebarURL.searchParams.delete(PREFILTER_KEY);

      fetchAndSwapSidebar(sidebarURL);
    };

    facetsForm.__maisonPrefilterPatched = true;
    patchedFacetsForm = facetsForm;

    return true;
  }

  function getReadyFacetsForm() {
    const facetsForm = document.querySelector(FACETS_DRAWER_SELECTOR);

    if (!facetsForm) return null;
    if (typeof facetsForm.createURLParameters !== 'function') return null;
    if (typeof facetsForm.updateFiltersByURL !== 'function') return null;

    return facetsForm;
  }

  /* ---------------- APPLY ---------------- */

  function applyPrefilter() {
    const facetsForm = getReadyFacetsForm();
    if (!facetsForm) return false;

    patchFacetsForm(facetsForm);

    const targetURL = buildPrefilterURL();
    const currentURL = getCurrentURL();

    if (!initialLoadDone) {
      if (targetURL.toString() !== currentURL.toString()) {
        facetsForm.updateFiltersByURL(targetURL.toString());
      } else {
        fetchAndSwapSidebar(currentURL);
      }

      initialLoadDone = true;
      return true;
    }

    return true;
  }

  function waitForFacetsAndApply() {
    if (waiting) return;
    waiting = true;

    let attempts = 0;
    const maxAttempts = 180;

    function check() {
      const ok = applyPrefilter();

      if (ok) {
        waiting = false;
        return;
      }

      attempts++;

      if (attempts >= maxAttempts) {
        waiting = false;
        console.warn('[prefilter] facets not ready');
        return;
      }

      requestAnimationFrame(check);
    }

    requestAnimationFrame(check);
  }

  /* ---------------- WATCH ---------------- */

  function watchForFacetsReplacement() {
    if (mutationObserver) return;

    mutationObserver = new MutationObserver(() => {
      const currentFacetsForm = getReadyFacetsForm();
      if (!currentFacetsForm) return;

      if (
        currentFacetsForm !== patchedFacetsForm ||
        !currentFacetsForm.__maisonPrefilterPatched
      ) {
        patchFacetsForm(currentFacetsForm);
      }
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  /* ---------------- INIT ---------------- */

  function bindLifecycle() {
    if (booted) return;
    booted = true;

    waitForFacetsAndApply();
    watchForFacetsReplacement();

    document.addEventListener('shopify:section:load', waitForFacetsAndApply);
    document.addEventListener('shopify:section:reorder', waitForFacetsAndApply);
    document.addEventListener('shopify:section:select', waitForFacetsAndApply);
    document.addEventListener('shopify:section:deselect', waitForFacetsAndApply);

    document.addEventListener('filter:update', () => {
      requestAnimationFrame(() => {
        const facetsForm = getReadyFacetsForm();
        if (!facetsForm) return;

        if (
          facetsForm !== patchedFacetsForm ||
          !facetsForm.__maisonPrefilterPatched
        ) {
          patchFacetsForm(facetsForm);
        }

        fetchAndSwapSidebar(getCurrentURL());
        revealCount();
      });
    });

    window.addEventListener('popstate', () => {
      requestAnimationFrame(() => {
        applyPrefilter();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLifecycle, { once: true });
  } else {
    bindLifecycle();
  }
})();